import { GLDistributionTableMultiSource } from "../../../backoffice/src/GLDistributionTableMultiSource";
import { Checkbox, DataSource, Layout, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutReceivablesHistoryExpand extends Layout {
    checkboxIsIntercompany: Checkbox;
    checkboxIsSplitBill: Checkbox;
    layoutGLDistributionTable: GLDistributionTableMultiSource;
    sourceJournalCash: DataSource;
    sourceJournalSales: DataSource;
    sourceJournalVm: DataSource;
    sourceReceivablesHistory: DataSource;
    tabGLDistribution: Tab;
    tabMain: Tab;
    tabsetReceivablesHistoryExpand: Tabset;
    textboxArReasonCodeId: Textbox;
    textboxCompanyId: Textbox;
    textboxDepositNumber: Textbox;
    textboxGlDate: Textbox;
    textboxRemark: Textbox;
    textboxShipDate: Textbox;
}
